import { View } from './view'

export const Controllers = View
